import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div<{ colors: IColors }>`
    padding: ${rem(40)} ${rem(20)} ${rem(15)} ${rem(20)};
    background: ${(props) => props.colors?.colorLightest};
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const TicketsHeader = styled.div<{ colors?: IColors; index?: number }>`
    background: ${(props) => props.colors.colorLightest};
    display: flex;
    flex-direction: row;
    text-align: center;
    padding-bottom: ${rem(25)};
    width: 100%;
    @media (max-width: ${breakpoints.xs}px) {
        padding-top: ${rem(25)};
        padding-bottom: ${rem(10)};
    }
    @media (min-width: ${breakpoints.xs}px) {
        ${({ index }) => (index === 0 ? `display: flex` : `display: none`)};
    }
`;

export const Ticket = styled.div<{ footer?: boolean }>`
    display: flex;
    flex-direction: row;
    text-align: center;
    padding-bottom: ${rem(25)};
    width: 100%;
    flex-direction: row;
    @media (max-width: ${breakpoints.xs}px) {
        ${({ footer }) => (footer ? `flex-direction: row` : `flex-direction: column`)};
    }
`;

export const TicketDetails = styled.div`
    display: flex;
    flex-direction: row;
`;

export const TicketContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TicketTitle = styled.div<{ footer?: boolean }>`
    text-align: left;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    width: ${rem(300)};
    display: flex;
    align-items: end;
    justify-content: start;
    @media (max-width: ${breakpoints.xs}px) {
        ${({ footer }) => (footer ? `width: 0` : `width: ${rem(300)}`)};
        padding-top: ${rem(15)};
    }
`;

export const TicketPrice = styled.div<{ footer?: boolean }>`
    width: ${rem(140)};
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ footer, theme }) => (footer ? `border-top: 1px solid ${theme.colors.secondaryGrey}` : ``)};
    ${({ footer }) => (footer ? `padding: ${rem(10)} 0` : ``)};
    ${({ footer, theme }) => (footer ? `font-weight: ${theme.fontWeights.textBold};` : ``)};
`;

export const TicketButtons = styled.div<{ footer?: boolean }>`
    border-radius: ${rem(4)};
    cursor: pointer;

    display: flex;
    flex-direction: row;

    color: ${({ theme }) => theme.colors.black};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    width: ${rem(110)};
    ${({ footer, theme }) => (footer ? `background: none` : `background: ${theme.colors.white}`)};
    ${({ footer, theme }) =>
        footer
            ? `border-top: 1px solid ${theme.colors.secondaryGrey}`
            : `border: 1px solid ${theme.colors.secondaryGrey}`};
    ${(prop) => (prop.footer ? `border-radius: ${rem(0)};` : `border-radius: ${rem(4)}`)};
`;

export const TicketButtonsHeader = styled.div`
    border-radius: ${rem(4)};
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.colors.black};
    width: ${rem(110)};
    background: none;
    border: none;
    justify-content: center;
`;

export const Plus = styled.span`
    padding: ${rem(5)} ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const Minus = styled.span`
    padding: ${rem(5)} ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const Count = styled.span`
    padding: 0 ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.h7};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const OrderForm = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-bottom: ${rem(25)};
    width: 100%;
`;

export const OrderFormPerson = styled.div`
    display: flex;
    flex-direction: row;
    text-align: left;
    padding-bottom: ${rem(25)};
    width: 100%;
    @media (max-width: ${breakpoints.sm}px) {
        flex-direction: column;
    }
`;

export const OrderFormCompany = styled.div`
    display: flex;
    flex-direction: row;
    text-align: left;
    padding-bottom: ${rem(25)};
    width: 100%;
    @media (max-width: ${breakpoints.sm}px) {
        flex-direction: column;
    }
`;

export const OrderFormDiscount = styled.div`
    display: flex;
    flex-direction: row;
    text-align: left;
    margin-bottom: ${rem(50)};
    width: 100%;
    
    @media (max-width: ${breakpoints.sm}px) {
        flex-direction: column;
        align-items: flex-start;
        gap: ${rem(15)};
    }
`;

export const Col1 = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-bottom: ${rem(25)};
    width: 100%;
`;
export const Col2 = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-bottom: ${rem(25)};
    width: 100%;
`;

export const OrderFormTickets = styled.div<{ colors: IColors }>``;

export const OrderGeneralText = styled.p``;

export const OrderTitleText = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding-bottom: ${rem(10)};
    padding-top: ${rem(20)};

    @media (max-width: ${breakpoints.xs}px) {
        padding-bottom: ${rem(20)};
    }
`;

export const InputSection = styled.div`
    position: relative;
    margin: ${rem(10)} ${rem(10)} ${rem(10)} ${rem(0)};
`;

export const Input = styled.input<{ marginBottom?: number }>`
    height: ${rem(45)};
    padding: ${rem(5)} ${rem(15)};
    border: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    width: ${rem(320)};
    border-radius: ${rem(4)};
    ${(prop) => (prop.marginBottom ? `margin-bottom: ${rem(prop.marginBottom)} !important` : '')}}

    &.error {
        border-color: ${({ theme }) => theme.colors.danger};
    }
`;

export const InputCount = styled.input`
    border: none;
    width: ${rem(30)};
    text-align: center;
`;

export const Select = styled.select<{ bottom?: number; top?: number }>`
    height: ${rem(45)};
    border: ${rem(12)} solid ${({ theme }) => theme.colors.white};
    outline: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    width: ${rem(320)};
    color: ${({ theme }) => theme.colors.grey};
    border-radius: ${rem(4)};
    margin-bottom: ${(props) => (props.bottom ? `${rem(props.bottom)}` : 0)};
    margin-top: ${(props) => (props.top ? `${rem(props.top)}` : 0)};
`;

export const Option = styled.option``;

export const Error = styled.span<{ bottom?: number }>`
    color: ${({ theme }) => theme.colors.danger};
    font-size: ${({ theme }) => theme.fontSizes.textSmall};
    position: absolute;
    left: 0;
    bottom: ${(props) => (props.bottom ? `-${rem(props.bottom)}` : `-${rem(14)}`)};
`;

export const CheckboxLabel = styled.span<{ colors: IColors }>`
    font-size: ${({ theme }) => theme.fontSizes.h7};
    a {
        color: ${(props) => props?.colors?.colorLink};
    }
`;

export const Agreements = styled.div``;

export const DiscountLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${rem(10)};
`;

export const DiscountCode = styled.div``;

export const Buttons = styled.div`
    position: relative;
    text-align: center;
    padding: ${rem(20)} ${rem(30)};
`;

export const ButtonSendForm = styled.button<{ colors: IColors }>`
    background: ${(props) => props.colors?.colorButton};
    border: none;
    color: ${({ theme }) => theme.colors.white};
    border-radius: ${rem(4)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: 0 ${rem(40)};
    height: ${rem(45)};
    margin-right: ${rem(20)};
    margin-bottom: ${rem(10)};
    cursor: pointer;
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.dark};

    &:disabled {
        opacity: 0.5;
    }
`;

export const SuccessMessage = styled.span`
    color: ${({ theme }) => theme.colors.primary};
`;
